module.exports = __webpack_public_path__ + "img/图片23.d0dbc245.png";